export default __webpack_public_path__ + "static/media/target_bg.19508bca.png";